import { render } from "./stopQuery.vue?vue&type=template&id=38b8b497&scoped=true"
import script from "./stopQuery.vue?vue&type=script&lang=js"
export * from "./stopQuery.vue?vue&type=script&lang=js"

import "./stopQuery.vue?vue&type=style&index=0&id=38b8b497&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b8b497"]])

export default __exports__